
export const tabs = [
  {
    name: "2018",
    id: "0",
  },
  {
    name: "2019",
    id: "1",
  },
  {
    name: "2020",
    id: "2",
  },
  {
    name: "2021",
    id: "3",
  },
  {
    name: "2022",
    id: "4",
  },
  {
    name: "2023",
    id: "5",
  },
  {
    name: "2024",
    id: "6",
  },
  {
    name: "2025",
    id: "7",
  },
]

export const tabContent = [
  {
    id: "0",
    year: "2018",
    caption: "ChainSafe receives first-ever grant from Vitalik Buterin to develop Lodestar.",
    imgUrl: "/yolo.png"
  },
  {
    id: "1",
    year: "2019",
    caption: "ChainSafe receives a grant to develop tooling such as SSZ, BLS, and SHA256-AS for Ethereum Consensus (eth2) in the JS ecosystem.",
    imgUrl: "/lodestar-2019.png"
  },
  {
    id: "2",
    year: "2020",
    caption: "Lodestar participates in early beacon chain testnets such as Medalla with the staking community.",
    imgUrl: "/medalla.png"
  },
  {
    id: "3",
    year: "2021",
    caption: "Proposed the first Lodestar mainnet block on Ethereum. Released first in-browser light client demonstration that tracks consensus using sync committees.",
    imgUrl: "/demo.png"
  },
  {
    id: "4",
    year: "2022",
    caption: "Successfully participated in the Ethereum merge to Proof-of-Stake. Released Lodestar v1.0.",
    imgUrl: "/panda.png"
  },
  {
    id: "5",
    year: "2023",
    caption: "Lodestar proposes the first block on the new 1.4M validator public testnet, Holesky.",
    imgUrl: "/holesky-dark.png"
  },
  {
    id: "6",
    year: "2024",
    caption: "Shipped Dencun hard fork with over 2% of mainnet share.",
    imgUrl: "/lodestar-diversity-2024.png"
  },
  {
    id: "7",
    year: "2025",
    caption: "Lodestar is rewriting core modules in Zig and switching to Bun as the primary runtime for Lodestar v2.0.",
    imgUrl: "/zig-bun.png"
  },
];
